import React, { useState, useCallback, useEffect } from 'react'
import { useStyles } from './styles'
import { ImportIcon } from 'src/assets/svg'

type CardProps = {
  image?: string
  onChange?: (file: File | null) => void
}

export const ImportImage: React.FC<CardProps> = ({ image, onChange }) => {
  const style = useStyles()

  const [imagePreview, setImagePreview] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (image) {
      if (image.startsWith('data:image')) {
        setImagePreview(image)
      } else {
        const imageWithPrefix = `data:image/jpeg;base64,${image}`
        setImagePreview(imageWithPrefix)
      }
    }
  }, [image])

  const handleFile = useCallback(
    (file: File) => {
      if (!file.type.startsWith('image/')) {
        setError('Selecione um arquivo de imagem válido.')
        return
      }

      const reader = new FileReader()
      reader.onload = (e: ProgressEvent<FileReader>) => {
        const result = e.target?.result as string
        setImagePreview(result)
        setError(null)
        if (onChange) onChange(file)
      }
      reader.readAsDataURL(file)
    },
    [onChange]
  )

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file) {
      handleFile(file)
    }
    e.target.value = ''
  }

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    const file = e.dataTransfer.files[0]
    if (file) handleFile(file)
  }

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
  }

  const handleRemoveImage = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    setImagePreview(null)
    setError(null)
    onChange?.(null)
  }

  return (
    <>
      <div
        className={style.cardContainer}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onClick={() => document.getElementById('file-input')?.click()}
      >
        <input id='file-input' type='file' accept='image/*' style={{ display: 'none' }} onChange={handleInputChange} />

        <div className={style.cardContent}>
          {imagePreview ? (
            <>
              <img src={imagePreview} alt='Preview' className={style.imagePreview} />
              <button onClick={handleRemoveImage} className={style.removeButton}>
                Remover
              </button>
            </>
          ) : (
            <div className={style.contentData}>
              <span>
                <ImportIcon />
              </span>
              <span>Clique ou arraste a imagem do animal</span>
            </div>
          )}
        </div>
      </div>
      {error && <span className={style.errorText}>{error}</span>}
    </>
  )
}
